import { render, staticRenderFns } from "./FadeRenderTransition.vue?vue&type=template&id=565352b3"
import script from "./FadeRenderTransition.vue?vue&type=script&lang=js"
export * from "./FadeRenderTransition.vue?vue&type=script&lang=js"
import style0 from "./FadeRenderTransition.vue?vue&type=style&index=0&id=565352b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports